const readItem = (key: string, fallback: string): string => {
	try {
		return localStorage.getItem(key) || fallback;
	} catch {
		return fallback;
	}
};

const parseJson = <T>(key: string, fallback: T): T => {
	const raw = localStorage.getItem(key);
	if (!raw) return fallback;
	try {
		return JSON.parse(raw) as T;
	} catch {
		localStorage.removeItem(key);
		return fallback;
	}
};

const persistToLocalStorage = <T>(key: string, value: T, setState: (value: T) => void): void => {
	localStorage.setItem(key, JSON.stringify(value));
	setState(value);
};

const localStorageUtils = { parseJson, persistToLocalStorage, readItem };
export default localStorageUtils;
